import React from 'react';
function AppVersion() {
  return (
    <span>1.0.2.1+develop:608f38b0.764</span> 
    /* WARNING!! Don't change anything in version number, its a template text and get replace by build pipeline */
  );
};
export default AppVersion;